import ArchiveDocumentRepository from "../domain/data/ArchiveDocumentRepository";
import { ArchiveDocument, ArchiveFile } from "../domain/entities/ArchiveDocument";

export default class MockArchiveDocumentRepository
  implements ArchiveDocumentRepository
{
  async searchArchive(
    orgId: string,
    lastName: string,
    firstName: string,
    studentId: string
  ): Promise<ArchiveDocument[]> {
    return [];
  }

  async listArchiveFiles(
    orgId: string,
    folderId: string
  ): Promise<ArchiveFile[]> {
    return [];
  }

  async getArchiveFile(
    orgId: string,
    folderId: string,
    fileName: string
  ): Promise<Blob> {
    return new Blob();
  }

  async getOrderData(
    orgId: string,
    folderId: string
  ): Promise<Record<string, any>> {
    return {};
  }
}
